/**
 * Constants for CardBody component
 * Contains repeated class names, styles, placeholder texts, and other constants
 */

// CSS Class Names
export const CSS_CLASSES = {
  CURSOR: "cursor",
  INPUT_EDIT_PROJECT: "input-edit-project",
  INPUT_BG: "input-bg",
  TOOLTIP_TRACKER: "tooltip-tracker",
  PROJECT_TRACKER_INNER: "project-tracker-inner",
  PROJECT_NAME_TRACKER: "project-name-tracker",
  TAG_AVAILABLE: "tag-available",
  TAG_NOT_AVAILABLE: "tag-not-available",
  TAG_EDIT_TAG_NAME: "tag-edit-tag-name",
  CUSTOM_DROPDOWN: "custom-dropdown",
  NEW_ACTIVE_INACTIVE: "new-active-inactive",
  SEARCH_BAR: "search-bar",
  CLIENT_LIST: "client-list",
  TRACKER_WHO_LIST: "tracker-who-list",
  CLIENT_LIST_FILTER: "client-list-filter",
  FILTER_ACTIVE_NO: "filter-active-no",
  MAIN_OUTER_ITEM_DD: "main-outer-item-dd",
  CLIENT_NAME1: "client-name1",
  SELECTED: "selected",
  MAIN_PROJECT: "main-project",
  ARROW: "arrow",
  OPEN: "open",
  PROJECT_NAME1_OUTER: "project-name1-outer",
  PROJECT_NAME1: "project-name1",
  PROJECT_DD_TITLE: "project-dd-title",
  SPRINT_LIST: "sprint-list",
  STATUS_LIST: "status-list",
  SELECTED_ITEM: "selected-item",
  USER_STATUS_DROPDOWN: "user-status-dropdown",
  USER_STATUS_DROPDOWN_LABEL: "user-status-dropdown-label",
  CUSTOM_DROPDOWN_USER: "custom-dropdown-user",
  SHOWING_NAME: "showing-name",
  TOP_SEARCH_TRACKER_FOR: "top-search-tracker-for",
  DROPDOWN_MENU1: "dropdown-menu1",
  DROPDOWN_TOGGLE1: "dropdown-toggle1",
  EDIT_TIME: "edit-time",
  EDIT_TIME_START: "edit-time-start",
  EDIT_TIME_END: "edit-time-end",
  TIME_SHOW: "time-show",
  DATE_OVERVIEW_SEC: "date-overview-sec",
  DATE_OVERVIEW_EDIT: "date-overview-edit",
  CUSTOM_DATE_ICON: "custom-date-icon",
  TIME_OVERVIEW_SEC: "time-overview-sec",
  TIMER_SEC_INPUT: "timer-sec-input",
  BEFORE_EDIT_INPUT: "before-edit-input",
  PLAY_BUTTON: "play-button",
  SET_BUTTON: "set-button",
  SET_BTN_OUTER: "set-btn-outer",
  DISABLED: "disabled",
  OUTTER_LOAD_TABLE: "outter-load-table",
  BILLABLE_TIMING_SEC: "billable-timing-sec",
  BILLABLE_TIMING: "billable-timing",
  NON_BILLABLE_TIMING: "non-billable-timing",
  SMALL: "small",
  LARGE: "large",
};

// Placeholder Texts
export const PLACEHOLDERS = {
  REGULAR_INPUT: "Regular Input",
  SEARCH: "Search...",
  FIND_PROJECT_OR_CLIENT: "Find Project or Client",
  TIME_FORMAT: "00:00:00",
};

// Default Values
export const DEFAULT_VALUES = {
  PROJECT_STATUS_FILTER: "Active",
  START_TIME_12: "07:46 PM",
  END_TIME_12: "08:50 PM",
  START_TIME_24: "7:46pm",
  END_TIME_24: "8:50pm",
  WEEK_START_MONDAY: "Monday",
};

// Color Constants
export const COLORS = {
  ERROR_BACKGROUND: "#fddada",
  EDITING_BACKGROUND: "#f0f7f9",
  WHITE: "#fff",
};

// Inline Styles
export const INLINE_STYLES = {
  ELLIPSIS_TEXT: {
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    height: "22px",
  },
  ELLIPSIS_TEXT_MOBILE: {
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    height: "22px",
    maxWidth: "140px",
  },
  TEXT_ELLIPSIS: {
    textOverflow: "ellipsis",
  },
  ERROR_BACKGROUND: {
    backgroundColor: COLORS.ERROR_BACKGROUND,
  },
  CURSOR_POINTER: {
    cursor: "pointer",
  },
  CURSOR_NOT_ALLOWED: {
    cursor: "not-allowed",
  },
  DISPLAY_NONE: {
    display: "none",
  },
  EDITING_BACKGROUND: {
    backgroundColor: COLORS.EDITING_BACKGROUND,
  },
  EDITING_PADDING: {
    padding: "10px",
  },
  TAG_ELLIPSIS: {
    display: "inline-block",
    maxWidth: "180px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  TAG_ELLIPSIS_NO_MAX_WIDTH: {
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  POSITION_RELATIVE: {
    position: "relative",
  },
};

// Messages
export const MESSAGES = {
  NO_PROJECTS_UNDER_CLIENT: "No projects under this client",
  NO_SPRINTS_UNDER_PROJECT: "No sprints under this project",
  DUPLICATE: "Duplicate",
  DELETE: "Delete",
  FILTER_BY_STATUS: "Filter by Status",
  PROJECTS: "Projects",
  SPRINTS: "Sprints",
};

// Status Options
export const STATUS_OPTIONS = {
  ALL: "All",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};
